import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { PostsReducer, toggleMenu } from "./reducers/PostsReducer";
import thunk from "redux-thunk";
import { AuthReducer } from "./reducers/AuthReducer";
import todoReducers from "./reducers/Reducers";
import { AudienceReducer } from "./reducers/AudienceReducer";
import { VenueReducer } from "./reducers/VenueReducer";
import { InitiativeReducer } from "./reducers/InitiativeReducer";
import { PerformanceVenueReducer } from "./reducers/PerformanceVenueReducer";
import { CountryReducer } from "./reducers/CountryReducer";
import { StateReducer } from "./reducers/StateReducer";
import { CityReducer } from "./reducers/CityReducer";
import { CategoryReducer } from "./reducers/CategoryReducer";
import { GenreReducer } from "./reducers/GenreReducer";
import { ShowReducer } from "./reducers/ShowReducer";
import { UsersReducer } from "./reducers/UserReducer";
import { ProjectReducer } from "./reducers/ProjectReducer";
import { ArtistReducer } from "./reducers/ArtistsReducer";
import { RbacReducer } from "./reducers/RbacReducer";
import { AppFeedReducer } from "./reducers/AppFeedReducer";
import { SystemConfigReducer } from "./reducers/SystemConfigReducer";
const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reducers = combineReducers({
  sideMenu: toggleMenu,
  auth: AuthReducer,
  audience: AudienceReducer,
  users: UsersReducer,
  venue: VenueReducer,
  initiative: InitiativeReducer,
  performanceVenue: PerformanceVenueReducer,
  country: CountryReducer,
  state: StateReducer,
  city: CityReducer,
  category: CategoryReducer,
  genre: GenreReducer,
  rbac: RbacReducer,
  show: ShowReducer,
  appfeed: AppFeedReducer,
  projects: ProjectReducer,
  artists: ArtistReducer,
  systemconfig: SystemConfigReducer,
});

export const store = createStore(reducers, composeEnhancers(middleware));
